import { render, staticRenderFns } from "./XhMultipleSelect.vue?vue&type=template&id=42b139db&scoped=true"
import script from "./XhMultipleSelect.vue?vue&type=script&lang=js"
export * from "./XhMultipleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b139db",
  null
  
)

export default component.exports